// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JioHN{transition:all .2s ease}.JioHN:hover{box-shadow:4px 4px 0px 0px #000}`, "",{"version":3,"sources":["webpack://./src/components/sprintCard/SprintCard.module.scss"],"names":[],"mappings":"AAAA,OACI,uBAAA,CAEA,aACI,+BAAA","sourcesContent":[".sprintCard {\n    transition: all 0.2s ease;\n\n    &:hover {\n        box-shadow: 4px 4px 0px 0px #000;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sprintCard": `JioHN`
};
export default ___CSS_LOADER_EXPORT___;
